import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Icon, Typography } from "@bookips/sds";
const CategoryHeader = (param)=>{
    let { title ="카테고리" , onClose , className  } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: cn("h-14 shrink-0 flex items-center justify-between px-5 py-4", "border-b border-gray-100 bg-white", className),
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle1",
                className: "text-primary",
                children: title
            }),
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                onClick: onClose,
                "aria-label": "닫기",
                children: /*#__PURE__*/ _jsx(Icon.Close_2px, {
                    className: "size-5 text-primary"
                })
            })
        ]
    });
};
export default CategoryHeader;
